<template>
  <div class="ts-bg-white">
    <section>
      <div
        class="ts-py-24 ts-bg-no-repeat ts-bg-cover"
        :style="{
        'background-image':
          'url(' + require('@/assets/front/images/inner-page-bg.jpg') + ')'
      }"
      >
        <div class="ts-container ts-mx-auto ts-px-4">
          <h2
            :class="$root.$i18n.locale == 'kh' ? 'ts-font-koulen ts-font-medium' : 'ts-font-heading-font'"
            class="ts-text-4xl sm:ts-text-6xl"
          >{{ $t('front.news') }}</h2>
          <ts-breadcrumb
            :class="$root.$i18n.locale == 'kh' ? 'ts-font-hanuman' : 'ts-font-robot'"
            class="ts-text-base"
            :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('front.news'),
            active: true
          }
        ]"
          />
        </div>
      </div>
    </section>
    <section class="ts-py-24">
      <div class="ts-container ts-mx-auto ts-px-4">
        <div class="ts-grid ts-grid-cols-1 lg:ts-grid-cols-3 ts-gap-8">
          <card-component :resource="{ img: '/assets/front/images/blog/1.jpg'}" />
          <card-component :resource="{ img: '/assets/front/images/blog/2.jpg'}" />
          <card-component :resource="{ img: '/assets/front/images/blog/3.jpg'}" />
          <card-component :resource="{ img: '/assets/front/images/blog/1.jpg'}" />
          <card-component :resource="{ img: '/assets/front/images/blog/2.jpg'}" />
          <card-component :resource="{ img: '/assets/front/images/blog/3.jpg'}" />
          <card-component :resource="{ img: '/assets/front/images/blog/1.jpg'}" />
          <card-component :resource="{ img: '/assets/front/images/blog/2.jpg'}" />
          <card-component :resource="{ img: '/assets/front/images/blog/3.jpg'}" />
        </div>
        <Paginate class="ts-mt-12" />
      </div>
    </section>
  </div>
</template>

<script>
import CardComponent from './components/card'
import Paginate from './components/paginate'
export default {
  name: 'news',
  components: {
    CardComponent,
    Paginate
  },
  data() {
    return {}
  },
  methods: {}
}
</script>